const EXTRA = "frameworkExtra";

/**
 * Stores a value in an HTML element. It can be retrieved later using
 * `getExtra` or `popExtra`.
 *
 * @param {HTMLElement} el
 * @param {String} key
 * @param {any} value
 */
export function setExtra(el, key, value) {
  ensureFrameworkExtra(el);
  el[EXTRA][key] = value;
}

/**
 * Checks if an extra value was set on the element.
 *
 * @param {HTMLElement} el
 * @param {String} key
 * @returns {Boolean}
 */
export function hasExtra(el, key) {
  ensureFrameworkExtra(el);
  return key in el[EXTRA];
}

/**
 * Retrieves a value previously set using `setExtra`. Returns `undefined`
 * if no value corresponding to the key was found.
 *
 * @param {HTMLElement} el
 * @param {String} key
 * @returns {any | undefined}
 */
export function getExtra(el, key) {
  ensureFrameworkExtra(el);
  return el[EXTRA][key];
}

/**
 * Retrieves and delete a value set using `setExtra`. Returns `undefined`
 * if no value corresponding to the key was found.
 *
 * @param {HTMLElement} el
 * @param {String} key
 * @returns {any | undefined}
 */
export function popExtra(el, key) {
  ensureFrameworkExtra(el);
  const value = el[EXTRA][key];
  delete el[EXTRA][key];
  return value;
}

/**
 * Deletes a value previously set using `setExtra`.
 *
 * @param {HTMLEleent} el
 * @param {String} key
 */
export function deleteExtra(el, key) {
  ensureFrameworkExtra(el);
  delete el[EXTRA][key];
}

function ensureFrameworkExtra(el) {
  if (!el[EXTRA]) {
    el[EXTRA] = {};
  }
}
